'use client'

import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Pagination } from 'swiper/modules'

// import 'swiper/css'
// import 'swiper/css/pagination'

const WhyPartnerSection = () => {
  const bulletPoints = [
    'Pioneering NEP–Aligned Educational Innovation',
    'Recognition of Prior Learning for Workforce Upskilling',
    'UGC–Approved Degree and Diploma Programmes',
    'NCVET–Approved Skill Certification Courses',
    'Boost Employee Retention and Loyalty',
    'Create Talent Pipeline, Reduce Hiring Costs',
    'Zero Payroll Costs for Employees',
    'CSR Exemptions for Corporate Partnerships',
    'Flexible Customization of Training Curriculum',
    'Government of India Financial Incentives',
  ]

  const recognitionLogos = [
    { src: 'https://cdn.msu.edu.in/logos/UGC.webp', alt: 'UGC' },
    { src: 'https://cdn.msu.edu.in/logos/NSDC.webp', alt: 'NSDC' },
    { src: 'https://cdn.msu.edu.in/logos/NCVET.webp', alt: 'NCVET' },
    { src: 'https://cdn.msu.edu.in/logos/Govt-of-Sikkim.webp', alt: 'Govt-of-Sikkim' },
    { src: 'https://cdn.msu.edu.in/logos/DGT.webp', alt: 'DGT' },
    { src: 'https://cdn.msu.edu.in/logos/AIU.webp', alt: 'AIU' },
    { src: 'https://cdn.msu.edu.in/logos/NAPS.webp', alt: 'NAPS' },
    { src: 'https://cdn.msu.edu.in/logos/iso-9001-2015.webp', alt: 'iso-9001-2015' },
    { src: 'https://cdn.msu.edu.in/logos/NATS.webp', alt: 'NATS' },
    { src: 'https://cdn.msu.edu.in/logos/iso-21001-2018.webp', alt: 'iso-21001-2018' },
    { src: 'https://cdn.msu.edu.in/logos/pharmacyCouncil_ndia.png', alt: 'pharmacy-council' },
    { src: 'https://cdn.msu.edu.in/logos/SNC.png', alt: 'SNC' },
    { src: 'https://cdn.msu.edu.in/logos/paramedicalCouncil_India.png', alt: 'paramedical-council' },
  ]

  return (
    <section className="section_block w-100">
      <div className="container text-center">
        <h2 className="fw-bold mb-4 title">Why Partner With Us?</h2>
      </div>

      <div className="container py-4">
        <div className="d-flex justify-content-center">
          <div
            className="row w-100 justify-content-center"
            style={{ maxWidth: '1000px' }}
            id="bullet-point-container"
          >
            {bulletPoints.map((item, index) => (
              <div key={index} className="col-12 col-md-6 mb-3 d-flex justify-content-start gap-5">
                <div className="d-flex align-items-start justify-content-center gap-3 text-start">
                  <div className="flex-shrink-0 mt-1">
                    <img
                      src="https://cdn.msu.edu.in/wise-lp/icons/start.png"
                      alt="Pointers"
                      width="18"
                    />
                  </div>
                  <p className="mb-0">{item}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="container d-flex align-items-center justify-content-center w-100">
        <Swiper
          modules={[Autoplay, Pagination]}
          className="recognition-image w-100 pt-4"
          loop
          speed={600}
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
          }}
          pagination={{ clickable: true }}
          slidesPerView={3}
          slidesPerGroup={3}
          breakpoints={{
            0: { slidesPerView: 3, slidesPerGroup: 3 },
            576: { slidesPerView: 3, slidesPerGroup: 3 },
            768: { slidesPerView: 4, slidesPerGroup: 4 },
            999: { slidesPerView: 5, slidesPerGroup: 5 },
            1100: { slidesPerView: 6, slidesPerGroup: 6 },
            // Desktop: show every logo statically, no sliding/autoplay/dots
            1300: {
              slidesPerView: recognitionLogos.length,
              slidesPerGroup: recognitionLogos.length,
              allowTouchMove: false,
              autoplay: false,
              loop: false,
            },
          }}
        >
          {recognitionLogos.map((logo, index) => (
            <SwiperSlide
              key={index}
              className="d-flex justify-content-center align-items-center"
            >
              <img src={logo.src} alt={logo.alt} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  )
}

export default WhyPartnerSection